<template>
  <!--  common-simple-row&#45;&#45;padding-->
  <div
    class="e4s-flex-column e4s-gap--small-qaz e4s-repeatable-grid--bottom common-simple-row--padding"
  >
    <slot></slot>
  </div>
</template>
